import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function AccessDeniedPage(): JSX.Element {
  return (
    <main className="flex min-h-[60vh] items-center justify-center px-4 py-12">
      <Card className="w-full max-w-xl">
        <CardHeader>
          <CardTitle className="text-2xl">Access denied</CardTitle>
          <CardDescription>You do not have permission to view this page.</CardDescription>
        </CardHeader>

        <CardContent>
          <p className="mb-4 text-sm text-foreground-muted-light dark:text-foreground-muted-dark">
            Return to the home page to continue browsing the portal, or contact an administrator if you believe this access should be available.
          </p>

          <Button asChild>
            <Link to="/">Go to home page</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
